import Bill from './Bill';

export default Bill;
